import React, { useMemo } from "react";
import { MyGeniusData } from "./mygenius.data";
import { getDuration, getLanguages } from "./mygenius.reference";
import { DisplayData, DisplayDataProps, DisplayDataWidget, translateLabelForData } from "@me8eon/data";
import { useAttributeValueComponents, useRenderers } from "@me8eon/renderers";
import { SimpleWidget } from "@me8eon/simple_widget";
import { ThemedIcon } from "@me8eon/icons"
// @ts-ignore
import icon from "./mygenius.svg";
import { useCommonComponents } from "@me8eon/components";
import { decodeHTML } from "@me8eon/string_utils";

export const MyGeniusDisplay: DisplayData<MyGeniusData> =
    ({ rootId, id, data }: DisplayDataProps<MyGeniusData>) => {
        const { ClipHeight } = useCommonComponents();
        const { H1WithIconAndUrl, Markdown, Url } = useRenderers();
        const { Text, DataLayout } = useAttributeValueComponents();
        const newRootId = `${rootId}.${id}`;
        const link = `https://eon.edcast.com/insights/${data.id}`;
        const cardTitle = decodeHTML(data.card_title);
        const cardDescription = data.card_description ? data.card_description?.replace(/<[^>]+>/g, ' ').replace(/\n/g, ' ') : data.card_description;
        const issueSummaryAndUrl = useMemo(() =>
            ({ url: link, title: cardTitle, icon: () => <ThemedIcon name={"mygenius"} /> }), [link, cardTitle]);

        const duration = getDuration(data?.Duration_HHMM)
        const language = getLanguages(data?.card_languages) || '<None>'

        return <DataLayout rootId={newRootId} className='jira-data' layout={[1, 1, 4, 1]}>
            <H1WithIconAndUrl rootId={newRootId} attribute={translateLabelForData('name')} value={issueSummaryAndUrl} />
            {cardDescription !== 'undefined' ? <ClipHeight maxHeight='2rem' force={false}>
                <Markdown rootId={id} attribute={translateLabelForData('data.description')} value={cardDescription} />
            </ClipHeight> : <></>}
            <Text rootId={id} attribute={translateLabelForData('source')} value={`"MyGenius - ["${data.ecl_source_name}"]"`} />
            <Text rootId={id} attribute={translateLabelForData('type')} value={data.type} />
            <Text rootId={id} attribute={translateLabelForData('duration')} value={duration} />
            <Text rootId={id} attribute={translateLabelForData('availableLanguages')} value={language} />
            <Url rootId={id} attribute={translateLabelForData('url')} value={link} />
        </DataLayout>;
    };

export const SimpleMyGeniusOneLineDisplay: DisplayData<MyGeniusData> =
    ({ data, listItemClicked }: DisplayDataProps<MyGeniusData>) => {
        const { SearchListItem } = useRenderers();

        const issueSummaryAndUrl = useMemo(() =>
        ({
            title: data.card_title,
            icon: () => <ThemedIcon name={"mygenius"} />,
            onClick: () => { listItemClicked && listItemClicked(data.card_title) }
        }), [data.card_title]);


        return (
            <SearchListItem key={data.card_title} rootId={data.card_title} attribute={translateLabelForData('name')} value={issueSummaryAndUrl} />
        )
    }
export const SimpleMyGeniusWidget: DisplayDataWidget<MyGeniusData> =
    SimpleWidget(
        ['issue', 'summary', 'status'],
        ['type', 'Duration_HHMM', "card_languages"],
        ['id']);

